import {Inject, Injectable} from '@angular/core';
import {CanActivate, Router} from '@angular/router';
import {CookieService} from 'ngx-cookie-service';
import {AuthService} from "../shared/services/auth.service";
import {APP_URL, LOGIN_URL} from "../api.token";
import {navigateToLoginPage} from "../shared/utilities/auth.util";

@Injectable({
    providedIn: 'root'
})
export class AuthGuard implements CanActivate {

    constructor(
        @Inject(APP_URL) private appUrl: string,
        @Inject(LOGIN_URL) private loginUrl: string,
        private router: Router,
        private authService: AuthService,
        private cookieService: CookieService,
    ) {
    }

    async canActivate(): Promise<boolean> {

        if (!this.authService.getToken()) {
            const tokenFromCookies = this.cookieService.get('access_token');
            if (tokenFromCookies) {
                this.authService.setToken(tokenFromCookies);
            }
        }

        if (this.authService.isLoggedIn()) {
            return true;
        }

        const {accessToken} = await this.getTokensFromUrl();
        if (accessToken) {
            this.authService.setToken(accessToken);
            return true;
        } else {
            navigateToLoginPage(this.appUrl, this.loginUrl);
            return false;
        }
    }

    private async getTokensFromUrl(): Promise<{ accessToken: string | null}> {
        const urlParams = new URLSearchParams(window.location.search);
        let accessToken = urlParams.get('access_token');


        if (accessToken ) {
            return {accessToken};
        }

        const maxAttempts = 5;
        for (let attempt = 0; attempt < maxAttempts; attempt++) {
            await new Promise(resolve => setTimeout(resolve, 200));
            accessToken = urlParams.get('access_token');
            if (accessToken) {
                return {accessToken};
            }
        }
        return {accessToken: null};
    }
}
